import { Divider, IconButton } from "@mui/material";
import React, { useState, useEffect } from "react";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import CloseIcon from '@mui/icons-material/Close';
const SearchFilter = ({ tables = [],
    matches, setMatches, currentIndex, setCurrentIndex
}) => {
    const [query, setQuery] = useState("");
    const [debouncedQuery, setDebouncedQuery] = useState("");

    const [openModal, setOpenModal] = useState(false)
    useEffect(() => {
        const handleKeyDown = (e) => {
            if (e.ctrlKey && e.key.toLowerCase() === 'f') {
                const selectedText = window.getSelection()?.toString() || '';
                e.preventDefault();
                setQuery(selectedText)
                setOpenModal(true);
            }

            if (openModal && e.key === 'Enter') {
                e.preventDefault();
                if (e.shiftKey) {
                    handlePrev();
                } else {
                    handleNext();
                }
            }

            if (e.key === 'Escape') {
                handleClose();
            }
        };

        window.addEventListener('keydown', handleKeyDown);
        return () => window.removeEventListener('keydown', handleKeyDown);
    }, [openModal, matches, currentIndex]);
    useEffect(() => {
        const timer = setTimeout(() => {
            setDebouncedQuery(query);
        }, 200);

        return () => clearTimeout(timer);
    }, [query]);
    const handleClose = () => {
        setQuery('')
        setOpenModal(false)
    }
    useEffect(() => {
        if (!debouncedQuery) {
            setMatches([]);
            return;
        }

        const lowerQuery = debouncedQuery.toLowerCase();

        const allMatches = tables.flatMap(table =>
            table.data.flatMap((row, rowIndex) => {

                if (row?.isSubHeadingRow) {

                    return []
                }

                if (row?.isTotalRow) {
                    return table.totalColDef.map((col) => {
                        const value = row[col.field];

                        if (
                            value &&
                            value.toString().toLowerCase().includes(lowerQuery)
                        ) {
                            return { tableId: table.id, rowIndex, field: col.field };
                        }
                        return null;
                    }).filter(Boolean);

                }

                return table.columnDefs.map((col) => {
                    const value = row[col.field];

                    if (
                        value &&
                        value.toString().toLowerCase().includes(lowerQuery)
                    ) {
                        return { tableId: table.id, rowIndex, field: col.field };
                    }
                    return null;
                }).filter(Boolean);
            })
        );
        setMatches(allMatches);
        setCurrentIndex(0);

    }, [debouncedQuery]);

    const handleNext = () => {
        if (matches.length === 0) return;

        const nextIndex = (currentIndex + 1) % matches.length;
        setCurrentIndex(nextIndex);
    };

    const handlePrev = () => {
        if (matches.length === 0) return;

        const prevIndex =
            (currentIndex - 1 + matches.length) % matches.length;
        setCurrentIndex(prevIndex);
    }
    return (
        <>
            {openModal &&
                <div style={{ position: 'fixed', top: '20px', right: '20px', zIndex: '999' }}>
                    <div
                        style={{
                            position: "fixed",
                            top: "10px",
                            right: "10%",
                            background: "#fff",
                            borderRadius: "8px",
                            boxShadow: "0 2px 6px rgb(32 33 36 / 28%)",
                            display: "flex",
                            alignItems: "center",
                            padding: "16px",
                            gap: "8px",
                            minWidth: "280px",
                            zIndex: 9999,
                            fontFamily: 'Roboto, Arial, sans-serif',
                        }}
                    >
                        <input
                            id="searchInput"
                            type="text"
                            placeholder="Search..."
                            value={query}
                            autoFocus
                            onChange={(e) => setQuery(e.target.value)}
                            style={{
                                flexGrow: 1,
                                border: "none",
                                outline: "none",
                                background: "transparent",
                                fontSize: "14px",
                                padding: "4px 8px",
                                borderRadius: "4px",
                            }}
                        />
                        <span
                            style={{
                                fontSize: "13px",
                                color: "#3c4043",
                                userSelect: "none",
                                minWidth: "32px",
                                textAlign: "center",
                            }}
                        >
                            {matches.length === 0 ? 0 : currentIndex + 1}/ {matches.length}
                        </span>
                        <Divider orientation="vertical" flexItem sx={{ borderColor: '#dadce0' }} />

                        <IconButton
                            size="small"
                            onClick={handlePrev}
                            aria-label="Previous match"
                            sx={{ color: "#3c4043", padding: '0px !important' }}
                        >
                            <KeyboardArrowUpIcon />
                        </IconButton>
                        <IconButton
                            size="small"
                            onClick={handleNext}
                            aria-label="Next match"
                            sx={{ color: "#3c4043", padding: '0px !important' }}
                        >
                            <KeyboardArrowDownIcon />
                        </IconButton>

                        <IconButton
                            size="small"
                            onClick={handleClose}
                            aria-label="Close search"
                            sx={{ color: "#3c4043", padding: '0px !important' }}
                        >
                            <CloseIcon sx={{ fontSize: '20px !important' }} />
                        </IconButton>

                    </div>
                </div>
            }
        </>
    );
};



export default SearchFilter;